<button
	matRipple
	class="Button"
	[matTooltip]="hasTooltip"
	[matTooltipPosition]="tooltipPosition"
	[disabled]="isDisabled"
	[class.Button--isDisabled]="isDisabled"
	[class.Button--isFull]="isFull"
	[class.Button--hasIcon]="hasIcon"
	[class.Button--outline]="outline"
	[class.Button--error]="color === EButtonColor.red"
	(click)="emitClick()"
>
	<ng-content select="appIcon" />
	<ng-content />
</button>

